export default __webpack_public_path__ + "static/media/play.f4848b81.svg";